import { computed, ref } from 'vue'

import { useDocumentStore } from '@/store/document'

interface ElementsRef {
  [key: string]: HTMLElement
}

const isAllFillableFieldsLoaded = ref(false)

// Create a shared ref outside the composable
const sharedElementsRef = ref<ElementsRef>({})

export function useFillableFieldsV2() {
  const store = useDocumentStore()
  const fillableFieldTotalCount = computed(
    () => store.flatFillableFields.length
  )
  const getElementsRefMap = () => {
    return sharedElementsRef.value
  }

  const getElementRefById = (id: string) => {
    return sharedElementsRef.value[id]
  }

  const addElementRef = (id: string, element: HTMLElement) => {
    sharedElementsRef.value[id] = element
    if (
      Object.keys(sharedElementsRef.value).length ===
        fillableFieldTotalCount.value &&
      fillableFieldTotalCount.value > 0 &&
      !isAllFillableFieldsLoaded.value
    ) {
      setIsAllFillableFieldsLoaded()
    }
  }

  const setIsAllFillableFieldsLoaded = () => {
    isAllFillableFieldsLoaded.value = true
  }

  return {
    elementsRef: sharedElementsRef,
    getElementsRefMap,
    getElementRefById,
    addElementRef,
    isAllFillableFieldsLoaded,
    setIsAllFillableFieldsLoaded,
  }
}
